import { defineStore } from 'pinia';
import { ref, computed, watch } from 'vue';

export const useAuthStore = defineStore('auth', () => {
  const user = ref(null);
  const loading = ref(false);
  const isLoaded = ref(false);
  const completeEmail = ref(null);
  const currentMunicipality = computed(() => user?.value?.municipalities?.find(municipality => municipality.current));

  const isAuthenticated = computed(() => user.value !== null);

  // By watching the `municipalities` array with the `deep: true` option, we ensure that the `currentOffice` computed property
  // updates correctly whenever a municipality's `current`property is modified.
  watch(() => user.value?.municipalities, () => {}, { deep: true });

  return {
    user,
    isAuthenticated,
    loading,
    isLoaded,
    completeEmail,
    currentMunicipality,
  };
});
